export default function flashElementById(
  elementId: string,
  cssLevel: "error" | "warning",
): void {
  const element = document.getElementById(elementId);
  if (element !== null) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    element.classList.add("flashing");
    element.classList.add(cssLevel);
    setTimeout(() => {
      element.classList.remove("flashing");
      element.classList.remove(cssLevel);
    }, 3000);
  } else {
    console.warn("No element found for id", elementId);
  }
}
